import React, {PureComponent} from "react"
import {pagination, emptyList} from "@irati/utils/services/apollo"
import Query, {QueryComponentProps} from "@irati/utils/services/apollo/Query"
import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"
import {UserList} from "@irati/types"
import {QueryUsersForInternalArgs} from "@irati/types/ops"
import usersForInternalQuery from "../../services/queries/usersForInternal"

export const query = usersForInternalQuery

// can't export type from "../../services/queries/usersForInternal" due to RN, should change to that when it does support
export interface UsersForInternalVariables extends QueryUsersForInternalArgs {
  includeBusiness?: boolean
}

interface Props {
  query: any,
  variables: UsersForInternalVariables
}

export function userList(apollo: ApolloState): UserList {
  return apollo.data?.usersForInternal || emptyList()
}

export function getNextPage(apollo: ApolloState, variables: UsersForInternalVariables) {
  const {cursor} = userList(apollo)
  if (cursor) { // expect more?
    return apollo.nextPage({...variables, cursor})
  }
}

interface Props extends Omit<QueryComponentProps<{usersForInternal: UserList}, UsersForInternalVariables>, "query"> {}

export default class LoadUsersQuery extends PureComponent<Props> {
  render() {
    const {children, ...props} = this.props

    const variables = {
      includeBusiness: this.props.variables.includeBusiness || false,
      ...this.props.variables
    }

    return (
      <Query {...props} variables={variables} query={usersForInternalQuery}>
        {(apollo: ApolloState) => {
          const nextPage = (nextPageVariables: UsersForInternalVariables) => pagination({query, variables: nextPageVariables}, apollo)
          return children({...apollo, nextPage})
        }}
      </Query>
    )
  }
}
